import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./scss/index.scss";
import { useWishlist } from "@sdk/react";
import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import ReactSVG from "react-svg";
import { Overlay } from "../..";
import contactFormIcon from "../../../images/contact-form-icon.svg";
import saveIcon from "../../../images/save-icon.svg";
import saveInitial from "../../../images/save-initial.svg";
import saveSuccessIcon from "../../../images/save-success-icon.svg";
import shareIcon from "../../../images/share-icon.svg";
import productImage from "../../../images/share_door.png";
import closeImg from "../../../images/x.svg";
import { compareAttributes } from "../../ProductDetails/utils";
import { SaveProjectForm } from "./SaveProjectForm";
import { SaveSelect } from "./SaveSelect";
import { ShareIcons } from "./ShareIcons";
export var ShareState;

(function (ShareState) {
  ShareState["initial"] = "initial";
  ShareState["save"] = "save";
  ShareState["saveSuccess"] = "save-success";
  ShareState["share"] = "share";
  ShareState["addToWishlist"] = "add-to-wishlist";
})(ShareState || (ShareState = {}));

var transformProductName = function transformProductName(name) {
  var n = name.split("-").join(" ");
  return "".concat(n[0].toUpperCase()).concat(n.slice(1));
};

export function ShareProject(_ref) {
  var _FIXTURES;

  var overlay = _ref.overlay;
  var intl = useIntl();
  var FIXTURES = (_FIXTURES = {}, _defineProperty(_FIXTURES, ShareState.initial, {
    content: function ShareProjectSelect(props) {
      return React.createElement(SaveSelect, props);
    },
    image: saveInitial,
    text: "",
    title: intl.formatMessage(_defineProperty({
      defaultMessage: "Save for later your doors:",
      "id": "components.OverlayManager.ShareProject.ShareProject.967401779"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.967401779"))
  }), _defineProperty(_FIXTURES, ShareState.save, {
    content: function ShareProjectContent(props) {
      return React.createElement(SaveProjectForm, props);
    },
    image: saveIcon,
    text: intl.formatMessage(_defineProperty({
      defaultMessage: "It deserves to be saved and sent to your inbox.",
      "id": "components.OverlayManager.ShareProject.ShareProject.1113074838"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.1113074838")),
    title: intl.formatMessage(_defineProperty({
      defaultMessage: "Your design is aDOORable!",
      "id": "components.OverlayManager.ShareProject.ShareProject.2854925806"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.2854925806"))
  }), _defineProperty(_FIXTURES, ShareState.saveSuccess, {
    content: function ShareProjectContent(props) {
      return React.createElement(React.Fragment, null, React.createElement("p", null, intl.formatMessage(_defineProperty({
        defaultMessage: "Share your design with your friends and get their opinion:",
        "id": "components.OverlayManager.ShareProject.ShareProject.2984776068"
      }, "id", "components.OverlayManager.ShareProject.ShareProject.2984776068"))), React.createElement(ShareIcons, props));
    },
    image: saveSuccessIcon,
    text: intl.formatMessage(_defineProperty({
      defaultMessage: "You can easily watch it later. You can open it when you want on any device you would be using.",
      "id": "components.OverlayManager.ShareProject.ShareProject.949680775"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.949680775")),
    title: intl.formatMessage(_defineProperty({
      defaultMessage: "The link to your project was sent to your email",
      "id": "components.OverlayManager.ShareProject.ShareProject.2239186832"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.2239186832"))
  }), _defineProperty(_FIXTURES, ShareState.share, {
    content: function ShareProjectContent(props) {
      return React.createElement(ShareIcons, props);
    },
    image: contactFormIcon,
    text: intl.formatMessage(_defineProperty({
      defaultMessage: "Share designs with your friends. Let’s see what they think!",
      "id": "components.OverlayManager.ShareProject.ShareProject.1658229053"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.1658229053")),
    title: intl.formatMessage(_defineProperty({
      defaultMessage: "What do your family and relatives really think? Just ask.",
      "id": "components.OverlayManager.ShareProject.ShareProject.985433088"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.985433088"))
  }), _defineProperty(_FIXTURES, ShareState.addToWishlist, {
    content: function ShareProjectContent() {
      return React.createElement("div", {
        className: "share-project__content-wishlist"
      }, addedToWishlist ? React.createElement("span", null, intl.formatMessage(_defineProperty({
        defaultMessage: "We will keep you design safe.",
        "id": "components.OverlayManager.ShareProject.ShareProject.1181527739"
      }, "id", "components.OverlayManager.ShareProject.ShareProject.1181527739"))) : React.createElement("span", null, intl.formatMessage(_defineProperty({
        defaultMessage: "You creation is lost foreever.",
        "id": "components.OverlayManager.ShareProject.ShareProject.1922934440"
      }, "id", "components.OverlayManager.ShareProject.ShareProject.1922934440"))));
    },
    image: shareIcon,
    text: "",
    title: intl.formatMessage(_defineProperty({
      defaultMessage: "Save for later",
      "id": "components.OverlayManager.ShareProject.ShareProject.981766647"
    }, "id", "components.OverlayManager.ShareProject.ShareProject.981766647"))
  }), _FIXTURES);

  var _useState = useState(overlay.context.data.initialState || ShareState.initial),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var selectOption = function selectOption(newState) {
    setState(newState);
  };

  var _overlay$context$data = overlay.context.data,
      productCategory = _overlay$context$data.productCategory,
      variantId = _overlay$context$data.variantId,
      productId = _overlay$context$data.productId,
      productName = _overlay$context$data.productName,
      url = _overlay$context$data.url,
      selectedProductAttributes = _overlay$context$data.selectedProductAttributes;
  var isShowLeft = [ShareState.initial, ShareState.save, ShareState.saveSuccess, ShareState.share, ShareState.addToWishlist].includes(state);

  var _useWishlist = useWishlist(),
      wishlist = _useWishlist.wishlist;

  var isAddedToWishlist = useCallback(function () {
    return wishlist === null || wishlist === void 0 ? void 0 : wishlist.some(function (_ref2) {
      var variant = _ref2.variant,
          productAttributes = _ref2.productAttributes;

      if (variant.id !== variantId) {
        return false;
      }

      return compareAttributes(productAttributes, selectedProductAttributes);
    });
  }, [selectedProductAttributes, variantId, wishlist]);

  var _React$useState = React.useState(isAddedToWishlist()),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      addedToWishlist = _React$useState2[0],
      setAddedToWishlist = _React$useState2[1];

  React.useEffect(function () {
    var added = isAddedToWishlist();

    if (added !== addedToWishlist) {
      setAddedToWishlist(added);
    }
  }, [addedToWishlist, isAddedToWishlist, wishlist]);
  return React.createElement(Overlay, {
    context: overlay
  }, React.createElement("div", {
    className: "share-project"
  }, React.createElement(ReactSVG, {
    path: closeImg,
    onClick: overlay.hide,
    className: "share-project__close-icon"
  }), isShowLeft && React.createElement("div", {
    className: "share-project__left"
  }, productImage && React.createElement("img", {
    src: productImage,
    className: "share-project__product-image",
    alt: "icon"
  }), productCategory && React.createElement("p", {
    className: "share-project__product-category"
  }, productCategory), React.createElement("p", {
    className: "share-project__product-title"
  }, transformProductName(productName))), React.createElement("div", {
    className: "".concat(isShowLeft ? "" : "share-project__single-block", " share-project__right")
  }, React.createElement("img", {
    src: FIXTURES[state].image,
    className: "share-project__image",
    alt: "icon"
  }), React.createElement("h4", {
    className: "share-project__title"
  }, FIXTURES[state].title), FIXTURES[state].text && React.createElement("p", {
    className: "share-project__text"
  }, FIXTURES[state].text), React.createElement("div", {
    className: "share-project__content"
  }, FIXTURES[state].content({
    addedToWishlist: addedToWishlist,
    onSuccess: function onSuccess() {
      if (state === ShareState.save) {
        setState(ShareState.saveSuccess);
      }
    },
    productId: productId,
    selectOption: selectOption,
    selectedProductAttributes: selectedProductAttributes,
    url: url,
    variantId: variantId
  })))));
}